import { render, staticRenderFns } from "./myForm.vue?vue&type=template&id=0dbcb620&scoped=true&"
import script from "./myForm.vue?vue&type=script&lang=js&"
export * from "./myForm.vue?vue&type=script&lang=js&"
import style0 from "./myForm.vue?vue&type=style&index=0&id=0dbcb620&scoped=true&lang=scss&"
import style1 from "./myForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbcb620",
  null
  
)

export default component.exports